import React from "react"
import PropTypes from "prop-types"
import {Box, Typography} from "@mui/material"
import ButtonWithIcon from "../../../../components/Button/Button"
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined"
import StatusBadge from "../../../../components/StatusBadge"
import StatusIconBadge from "src/v2/components/StatusIconBadge"

const FormHeader = ({
    title,
    onDownload,
    statusLabel = "Status",
    statusColor = "warning",
    statusIconColor = "warning",
    statusIcon,
    showDownload = false,
}) => (
    <Box
        sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            gap: {xxxs: 1.5, md: 3}
        }}
    >
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 1,
                minWidth: 0
            }}
        >
            {statusIcon ? (
                <StatusIconBadge label={statusLabel} color={statusColor} iconColor={statusIconColor} icon={statusIcon} />
            ) : (
                <StatusBadge label={statusLabel} backgroundColor={statusColor} />
            )        
        }
            
            <Typography variant="h2" color="common.white"
                sx={{
                    marginTop: 1,
                    marginBottom: 3,
                }}
            >
                {title}
            </Typography>
        </Box>
        {showDownload && (
            <Box sx={{display: "flex", alignItems: "center", gap: 2, minWidth: 0, marginTop: 3}}>
                <ButtonWithIcon
                    size="md"
                    icon={<FileDownloadOutlinedIcon />}
                    onClick={onDownload}
                >
                    BAIXAR ARQUIVO
                </ButtonWithIcon>
            </Box>
        )}
    </Box>
)

FormHeader.propTypes = {
    title: PropTypes.string.isRequired,
    onDownload: PropTypes.func,
    statusLabel: PropTypes.string,
    statusColor: PropTypes.string,
    statusIconColor: PropTypes.string,
    statusIcon: PropTypes.node,
    showDownload: PropTypes.bool,
}

export default FormHeader
